class BGStartHub extends HTMLElement {
  connectedCallback() {
    try {
      this.products = JSON.parse(this.querySelector('[data-bg-start-product-json]').textContent);
    } catch (error) {
      console.error('BRAINGAIN Start page product data is invalid.', error);
      return;
    }
    this.cards = [...this.querySelectorAll('[data-bg-start-support-product]')];
    this.panel = this.querySelector('[data-bg-start-panel]');
    this.supportSection = this.querySelector('[data-bg-start-support-section]');
    this.locale = (this.getAttribute('data-bg-start-locale') || 'en').split('-')[0];
    this.bindEvents();
    const requested = new URL(location.href).searchParams.get('product');
    if (requested && this.products[requested]) this.selectProduct(requested, false);
  }

  bindEvents() {
    this.cards.forEach(card => card.addEventListener('click', () => this.selectProduct(card.getAttribute('data-bg-start-handle'), true)));
    this.querySelector('[data-bg-start-product-search]')?.addEventListener('input', event => this.filterProducts(event.target.value));
    this.querySelector('[data-bg-start-change-product]')?.addEventListener('click', () => {
      this.smoothScrollTo(this.querySelector('[data-bg-start-picker]'));
      setTimeout(() => this.querySelector('[data-bg-start-product-search]')?.focus(), 850);
    });
    this.querySelectorAll('[role="tab"]').forEach(tab => tab.addEventListener('click', () => this.openTab(tab.getAttribute('data-bg-start-tab'))));
    window.addEventListener('klaviyoForms', event => {
      if (event.detail?.type === 'submit') this.querySelector('[data-bg-start-discount-code]')?.removeAttribute('hidden');
    });
    this.observeWarrantyForm();
  }

  filterProducts(value) {
    const query = value.trim().toLowerCase();
    let visible = 0;
    this.cards.forEach(card => {
      const show = !query || (card.getAttribute('data-bg-start-search') || '').includes(query);
      card.hidden = !show;
      if (show) visible++;
    });
    this.querySelector('[data-bg-start-empty]')?.classList.toggle('is-visible', visible === 0);
  }

  selectProduct(handle, shouldScroll) {
    const product = this.products[handle];
    if (!product) return;
    this.cards.forEach(card => {
      const selected = card.getAttribute('data-bg-start-handle') === handle;
      card.classList.toggle('is-selected', selected);
      card.setAttribute('aria-pressed', String(selected));
    });
    if (this.supportSection) this.supportSection.hidden = false;
    this.panel.hidden = false;
    this.selectedProductTitle = product.title;
    const selectedTitle = this.querySelector('[data-bg-start-selected-title]');
    if (selectedTitle) selectedTitle.textContent = product.title;
let image = this.querySelector('[data-bg-start-selected-image]');

if (!image) {
  image = document.createElement('img');
  image.className = 'bg-start__selected-image';
  image.setAttribute('data-bg-start-selected-image', '');
  image.width = 52;
  image.height = 52;

  const panelHeader = this.querySelector('.bg-start__panel-head');

  if (panelHeader) {
    panelHeader.prepend(image);
  }
}

if (image) {
  image.src =
    product.image ||
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

  image.alt = product.title;
}
    this.renderAssembly(product);
    this.renderManual(product);
    this.renderFixes(product);
    this.filterCrossSells(product.excludeCollection);
    this.setHiddenWarrantyProduct(product.title);
    this.openTab('assembly');
    const url = new URL(location.href);
    url.searchParams.set('product', handle);
    history.replaceState({}, '', url);
    if (shouldScroll) requestAnimationFrame(() => this.smoothScrollTo(this.supportSection || this.panel));
  }

  renderAssembly(product) {
    const rawVideo = product.videos[this.locale] || product.videos.en || '';
    const videoId = this.videoId(rawVideo);
    let box = this.querySelector('[data-bg-start-video]');
    if (!box) {
      box = document.createElement('div');
      box.className = 'bg-start__video';
      box.setAttribute('data-bg-start-video', '');
      this.querySelector('[data-bg-start-pane="assembly"]')?.prepend(box);
    }
    if (box) {
      box.innerHTML = videoId
        ? `<iframe loading="lazy" src="https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}" title="${this.escape(product.title)} assembly video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
        : `<div class="bg-start__video-empty">${this.escape(this.getAttribute('data-bg-start-no-video') || '')}</div>`;
    }
    this.setText('[data-bg-start-video-note]', product.videoNote);
    const languageFallback = this.querySelector('[data-bg-start-language-fallback]');
    if (languageFallback) languageFallback.hidden = !(videoId && this.locale !== 'en' && !product.videos[this.locale]);
    this.setLink('[data-bg-start-assembly-manual]', product.manual);
    this.setLink('[data-bg-start-assembly-contact]', this.contactUrl(product.title));
  }

  renderManual(product) {
    const manualTitle = this.querySelector('[data-bg-start-manual-title]');
    if (manualTitle) manualTitle.textContent = `${product.title} manual`;
    this.setLink('[data-bg-start-manual-download]', product.manual);
    this.setLink('[data-bg-start-manual-safety]', product.safetyUrl);
  }

  renderFixes(product) {
    let container = this.querySelector('[data-bg-start-fixes]');
    if (!container) {
      container = document.createElement('div');
      container.setAttribute('data-bg-start-fixes', '');
      this.querySelector('[data-bg-start-pane="fixes"]')?.prepend(container);
    }
    if (!container) return;
    container.innerHTML = '';
    if (!product.fixes.length) {
      container.innerHTML = `<p class="bg-start__notice">${this.escape(this.getAttribute('data-bg-start-no-fixes') || '')}</p>`;
      return;
    }
    product.fixes.forEach(fix => {
      if (!fix.title || !fix.url) return;
      const row = document.createElement('div');
      row.className = 'bg-start__action';
      row.innerHTML = `<span class="bg-start__action-icon"><svg version="1.1" id="fi_953812" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M501.818,90.997c-1.876-4.733-6.008-8.204-10.993-9.234c-4.992-1.032-10.157,0.516-13.756,4.116l-77.994,77.994
			l-41.932-9.016l-9.015-41.932l77.994-77.995c3.6-3.6,5.146-8.77,4.116-13.755c-1.031-4.986-4.502-9.117-9.234-10.995
			c-53.547-21.234-114.462-8.644-155.187,32.078c-19.604,19.604-33.066,44.226-38.93,71.206
			c-5.016,23.082-4.312,46.931,1.991,69.544L20.734,391.153C7.363,404.523,0,422.3,0,441.209c0,18.909,7.363,36.686,20.735,50.057
			C34.105,504.637,51.882,512,70.791,512c18.908,0,36.686-7.363,50.056-20.734l208.145-208.144
			c22.613,6.303,46.461,7.007,69.543,1.99c26.98-5.864,51.603-19.327,71.207-38.93C510.463,205.459,523.053,144.546,501.818,90.997z
			 M448.354,224.796c-30.845,30.845-77.377,41.402-118.55,26.89c-5.49-1.934-11.602-0.546-15.719,3.57L99.46,469.88
			c-7.658,7.659-17.841,11.877-28.671,11.877c-10.831,0-21.012-4.218-28.671-11.877c-7.658-7.659-11.876-17.841-11.876-28.671
			c0-10.83,4.218-21.012,11.877-28.671l214.624-214.624c4.116-4.116,5.504-10.229,3.57-15.719
			c-14.511-41.171-3.956-87.705,26.889-118.55c21.8-21.8,50.919-33.398,80.596-33.398c6.226,0,12.479,0.51,18.69,1.545l-65.57,65.57
			c-3.63,3.629-5.171,8.852-4.092,13.871l12.799,59.533c1.251,5.814,5.792,10.355,11.605,11.605l59.534,12.8
			c5.022,1.079,10.241-0.462,13.872-4.092l65.569-65.57C486.17,161.332,474.726,198.423,448.354,224.796z"></path>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg></span><div class="bg-start__action-copy"><strong>${this.escape(fix.title)}</strong>${fix.description ? `<small>${this.escape(fix.description)}</small>` : ''}</div><a class="bg-start__button bg-start__button--outline" href="${this.safeUrl(fix.url)}" target="_blank" rel="noopener">${this.escape(this.getAttribute('data-bg-start-watch-label') || 'Watch')}</a>`;
      container.appendChild(row);
    });
  }

  filterCrossSells(excludedCollection) {
    let visible = 0;
    this.querySelectorAll('[data-bg-start-cross-sell]').forEach(card => {
      const collections = (card.getAttribute('data-bg-start-collections') || '').split(' ').filter(Boolean);
      const hide = Boolean(excludedCollection && collections.includes(excludedCollection));
      card.hidden = hide;
      if (!hide) visible++;
    });
    this.querySelector('[data-bg-start-cross-empty]')?.toggleAttribute('hidden', visible !== 0);
  }

  openTab(name) {
    this.querySelectorAll('[role="tab"]').forEach(tab => tab.setAttribute('aria-selected', String(tab.getAttribute('data-bg-start-tab') === name)));
    this.querySelectorAll('[role="tabpanel"]').forEach(panel => panel.hidden = panel.getAttribute('data-bg-start-pane') !== name);
  }

  smoothScrollTo(element) {
    if (!element) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const header = document.querySelector('.section-header, #shopify-section-header, header[role="banner"]');
    const headerHeight = header ? Math.min(header.getBoundingClientRect().height, 140) : 0;
    const start = window.pageYOffset;
    const destination = Math.max(0, element.getBoundingClientRect().top + start - headerHeight - 16);
    if (reduceMotion) { window.scrollTo(0, destination); return; }
    const duration = 900;
    const started = performance.now();
    const ease = value => value < 0.5 ? 4 * value * value * value : 1 - Math.pow(-2 * value + 2, 3) / 2;
    const frame = now => {
      const progress = Math.min((now - started) / duration, 1);
      window.scrollTo(0, start + (destination - start) * ease(progress));
      if (progress < 1) requestAnimationFrame(frame);
    };
    requestAnimationFrame(frame);
  }

  observeWarrantyForm() {
    const root = this.querySelector('[data-bg-start-warranty-slot]');
    if (!root) return;
    const attach = () => {
      const warrantyEmail = root.querySelector('input[type="email"]');
      const offerEmail = this.querySelector('[data-offer-email], .klaviyo-form input[type="email"]');
      if (warrantyEmail && !warrantyEmail.dataset.bgBound) {
        warrantyEmail.dataset.bgBound = 'true';
        warrantyEmail.addEventListener('input', () => { if (offerEmail) offerEmail.value = warrantyEmail.value; });
      }
      if (offerEmail && !offerEmail.dataset.bgBound) {
        offerEmail.dataset.bgBound = 'true';
        offerEmail.addEventListener('input', () => { if (warrantyEmail) warrantyEmail.value = offerEmail.value; });
      }
      this.setHiddenWarrantyProduct(this.selectedProductTitle || '');
    };
    new MutationObserver(attach).observe(root, { childList: true, subtree: true });
    attach();
  }

  setHiddenWarrantyProduct(title) {
    const field = this.querySelector('.globo-formbuilder [name*="product" i]');
    if (field && title) field.value = title;
  }

  contactUrl(title) {
    const contactUrl = this.getAttribute('data-bg-start-contact-url') || '';
    if (!contactUrl) return '#';
    const separator = contactUrl.includes('?') ? '&' : '?';
    return `${contactUrl}${separator}product=${encodeURIComponent(title)}`;
  }
  setText(selector, value) { const element = this.querySelector(selector); if (!element) return; element.textContent = value || ''; element.hidden = !value; }
  setLink(selector, url) { const element = this.querySelector(selector); if (!element) return; element.href = url || '#'; element.toggleAttribute('aria-disabled', !url); }
  videoId(value = '') { const string = String(value).trim(); if (!string) return ''; try { const url = new URL(string); return url.searchParams.get('v') || url.pathname.split('/').filter(Boolean).pop() || ''; } catch { return string; } }
  safeUrl(value = '') { try { const url = new URL(value, location.origin); return ['http:', 'https:'].includes(url.protocol) ? url.href : '#'; } catch { return '#'; } }
  escape(value = '') { const div = document.createElement('div'); div.textContent = value; return div.innerHTML; }
}
if (!customElements.get('bg-start-hub')) customElements.define('bg-start-hub', BGStartHub);
